import React, { useContext } from "react";
import HeadingSection from "../HeadingSection";
import Header from "../Header";
import ContactConcierge from "../ContactConcierge";
import { DataContext } from "../../App";
import Seo from "../Seo";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const TemplateBox = () => {

    const context = useContext(DataContext)
    const pageContentExperience = context.pages.find(item => item.name === 'experiences');

    const isMobile = window.matchMedia("screen and (max-width: 767px)").matches;
    const isTablet = window.matchMedia("screen and (max-width: 1024px) and (min-width: 768px)").matches;

    return (
        <>
    <Seo
        title={pageContentExperience.pageContent?.seoInformation?.title ?? "Memorable experiences | Feeling Italy"}
        description={pageContentExperience.pageContent?.seoInformation?.metaDescription ?? "Discover exclusive concierge services with Feeling Italy. From private chefs and luxury transfers to personalized tours and unique experiences, let us make your Mediterranean vacation truly unforgettable."}
        keywords={pageContentExperience.pageContent?.seoInformation?.keywords ?? "Concierge Services, Feeling Italy Concierge, Private Chef Italy, Luxury Transfers Amalfi Coast, Personalized Tours Italy, Exclusive Mediterranean Experiences, Tailored Travel Services, Amalfi Coast Luxury Services, Custom Travel Assistance, Premium Guest Experiences"}
        url={window.location.href}
      />

            <Header background={"transparent"}/>
            <HeadingSection data={pageContentExperience.pageContent.heading} />
            <div className="text-center mt-5 mb-5 overflow-hidden py-templateBox">
                {pageContentExperience.pageContent.intro.title && (<h2 className="title text-center mb-2">{pageContentExperience.pageContent.intro.title}</h2>)}
            </div>
            <div className="container-fluid templateBox overflow-hidden ">
                {pageContentExperience.pageContent.experiences.map((item, index) => (
                    <section key={index} id={item.id}>
                        {
                            ((index % 2 === 0) || isMobile) ? (
                                <div className="row">
                                    {item?.image[0] && item?.image[0]?.objectUrl && (
                                        <div className="col-md-6 col-12 p-0">
                                            <img
                                                className="w-100"
                                                src={process.env.REACT_APP_SITE_URL + (item?.image && (item?.image[0]?.objectUrl ?? ""))}
                                                alt={(item.image?.name ?? item?.title) ?? ""}
                                            />
                                        </div>
                                    )}
                                    <div className="col-md-6 col-12 d-table vh-50Custom">
                                        <div className="paddingBox h-100 align-middle d-table-cell">
                                            <h3 className="title text-uppercase">{item.title}</h3>
                                            <div className="mt-5 mb-0 p-no-margin" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                               <div className={`arrowEffectContainer containerCtaTemplateBox`}>
                                                 <NavLink to={`/experiences/${item.cta?.url ?? item.title}`} className="link text-uppercase m-auto mt-5">
                                                   {item.cta?.text ?? ""} <FontAwesomeIcon icon={faArrowRight} className="paddingArrow effectArrow"/>
                                                 </NavLink>
                                               </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="row flex-flow-mobile">
                                    <div className="col-md-6 col-12 d-table vh-50Custom">
                                        <div className="paddingBox h-100 align-middle d-table-cell">
                                            <h4 className="title text-uppercase">{item.title}</h4>
                                            <div className="mt-5 mb-0 p-no-margin" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                            <div className={`arrowEffectContainer containerCtaTemplateBox`}>
                                                 <NavLink to={`/experiences/${item.cta?.url ?? item.title}`} className="link text-uppercase m-auto mt-5">
                                                   {item.cta?.text ?? ""} <FontAwesomeIcon icon={faArrowRight} className="paddingArrow effectArrow"/>
                                                 </NavLink>
                                               </div>
                                        </div>
                                    </div>
                                    {item?.image[0] && item.image[0]?.objectUrl && (
                                        <div className="col-md-6 col-12 p-0">
                                            <img
                                                className="w-100"
                                                src={process.env.REACT_APP_SITE_URL + (item?.image && (item.image[0]?.objectUrl ?? ""))}
                                                alt={(item.image?.name ?? item?.title) ?? ""}
                                            />
                                        </div>
                                    )}
                                </div>
                            )
                        }
                    </section>
                ))}
            </div>
            <ContactConcierge fromExperience={true} shadow={true} margin={`${(isTablet || isMobile) ? "-18vh" : "-30vh"}`}/>
        </>
    );
};

export default TemplateBox;
